/* eslint-disable */
import * as React from 'react';
import AppPage from '@/ui/AppPage/AppPage';
import Box from '@mui/material/Box';
import Permissions from '@/lib/permissions';
import { useParams } from 'react-router-dom';
import dataController from '@/lib/DataController';
import ThreeDSettingsModel from '@/models/three_d_settings';
import ThreeDSettingForm from './ThreeDSettingForm';

function ThreeDSettingAdminPage() {
  const { id } = useParams();
  const dc = new dataController(ThreeDSettingsModel);

  const recordId = parseInt(id ? id : '', 10);

  return (
    <AppPage
      titlett="admin:page.3d_setting"
      needPermission={[Permissions.Administration]}
    >
      <Box m={2}>
        <ThreeDSettingForm dc={dc} recordId={recordId} mode="update" form="update" />
      </Box>
    </AppPage>
  );
}

export default ThreeDSettingAdminPage;
